import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface Props {
  t: (key: string) => string;
  open: boolean;
  pendingAction: { type: 'ertelendi' | 'iptal'; stepId: number } | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function OperatingRoomConfirmDialog({ t, open, pendingAction, onCancel, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: pendingAction?.type === 'iptal' ? '#ffebee' : '#fff3e0',
          color: pendingAction?.type === 'iptal' ? '#c62828' : '#ef6c00',
        }}
      >
        {pendingAction?.type === 'iptal'
          ? t('surgery.confirmations.cancelled.title')
          : t('surgery.confirmations.postponed.title')}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body1">
          {pendingAction?.type === 'iptal'
            ? t('surgery.confirmations.cancelled.message')
            : t('surgery.confirmations.postponed.message')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" color="inherit">
          {t('surgery.confirmations.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={pendingAction?.type === 'iptal' ? 'error' : 'warning'}
          autoFocus
        >
          {pendingAction?.type === 'iptal'
            ? t('surgery.confirmations.cancelled.confirm')
            : t('surgery.confirmations.postponed.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
